module.exports = __webpack_public_path__ + "03_glasses_black.48205418.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/03_glasses_black.png
// module id = k+Mv
// module chunks = 0